export default {
  debug: false,
  testing: false,
  brand: "labc",
  amtrustUrl: "https://marleyriskconsultants.com/AELclaim"
};
